<div class="input-group search-field" [class.disabled]="disabled">
  <input type="text" class="form-control" [placeholder]="placeholder" [(ngModel)]="searchInputFieldText"
    autocomplete="off" (keydown)="textChanged()" (keydown.enter)="doSearch()" [id]="inputId" [disabled]="disabled">
  <div class="input-group-append">
    <sc-button
      type="primary"
      [prefixIcon]="showClear() ? 'close' : 'white-magnifier'"
      [iconOnly]="true"
      [id]="buttonId"
      (onClick)="buttonClicked()"
      [disabled]="disabled"
    ></sc-button>
  </div>
</div>